import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

export class Icon extends Component {

    render() {
        let symbol = 'Ł'
        if (!this.props.litecoin) {
            symbol = this.props.symbol
        }
        return (
            <Circle litecoin={this.props.litecoin}>
                {symbol}
            </Circle>
        )
    }
}

const Circle = styled.span`
    height: 25px;
    width: 25px;
    background-color: ${props => props.litecoin ? '#bbb' : '#20BF9F'};
    border-radius: 50%;
    display: inline-block;
    text-align: center;
    color: white;
    font-family: 'Ubuntu', sans-serif;
    font-size: larger;
    font-style: ${props => props.litecoin ? 'italic' : 'normal'};
    font-weight: 700;
`

const mapStateToProps = (state) => ({
    symbol: state.buy.params.currencySymbol
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Icon)
